export const selectorError = (state) => state.error;

export default selectorError;
